import { checkCookie, setCookie } from './lib/cookie-manipulation'
;(function (window) {
  window.newFormValidate = ({ form }) => {
    const signUpForm = form

    /**
     * Grab the parent element of a given element.
     * @param {*} selector
     *
     */
    const getParentElement = (selector) => {
      const el = signUpForm.querySelector(selector)
      if (el && el.parentElement) {
        return el.parentElement
      }
    }

    const updateElementAttribute = (el, attribute, message) => {
      if (el) {
        el.setAttribute(attribute, message)
      }
    }

    const getCountryValue = () => {
      const countryInput = document.querySelector('#user_country')
      if (countryInput) {
        return countryInput.value
      }
      return ''
    }

    const userEmailField = signUpForm.querySelector('.user_email')
    const submitBtn = signUpForm.querySelector('.form__submit')
    const twoStepBtn = signUpForm.querySelector('#two-step-submit-btn')
    const emailRegex = userEmailField.getAttribute('pattern')
    const emailDomainBlacklist = userEmailField.getAttribute(
      'blacklisted-domain-list'
    )

    const emailWarningMsg = userEmailField.getAttribute('data-type-notice')

    /**
     *  @type {Object} nudgeTracker - Holds information pertaining to work email nudge.
     *  @property {boolean} nudgeTracker.isDismissed - Keeps track if nudge was dismissed or not
     */
    const nudgeTracker = {
      wasNudgeDisplayed: false,
      isDismissed: false,
    }

    /**
     *  Holds an array of blacklisted domains from errors.yml -> validation_form_builder.rb
     */
    const blacklistedDomainsArray = JSON.parse(emailDomainBlacklist)

    /**
     *  Returns true if email is in domain blacklist.
     *  False otherwise
     * @param {string} email_value
     */
    const isEmailDomainInBlacklist = (email) => {
      /**
       *  domain ex: gmail.com
       *  hostname ex: gmail
       */
      const emailDomain = email.split('@')[1]
      const emailHostName = emailDomain?.split('.')[0]
      if (emailDomain || emailHostName) {
        return blacklistedDomainsArray.some((blacklisted_domain) => {
          return (
            blacklisted_domain === emailDomain.toLowerCase() ||
            blacklisted_domain === emailHostName.toLowerCase()
          )
        })
      }
    }

    /**
     *  Use regex pattern from GoCanvas Auth to validate the email field.
     *
     *  @param {string} email
     */
    const isEmailInValidFormat = (email) => {
      const emailRegexPattern = new RegExp(emailRegex)
      return emailRegexPattern.test(email)
    }

    /** Takes in a field ref and returns the validation data attribute */
    const whichError = (obj) => {
      if (obj.valueMissing) {
        return 'data-required-message'
      } else if (obj.tooShort) {
        return 'data-tooshort-message'
      } else if (obj.typeMismatch || obj.patternMismatch) {
        return 'data-type-message'
      } else if (obj.customError) {
        return 'data-invalid-message'
      }
    }

    const checkEmailBlacklist = (value) => isEmailDomainInBlacklist(value)
    const validateEmail = (emailField) => isEmailInValidFormat(emailField.value)

    const validateSelect = () => {
      if (!validateIndustyField()) {
        createErrorSpan(
          document.querySelector('.industry-dropdown'),
          'data-required-message'
        )
        showInputErrorState(document.querySelector('.select-selected'))
        return false
      } else {
        removeErrorSpanIfExists(document.querySelector('.industry-dropdown'))
        hideInputErrorState(document.querySelector('.select-selected'))
        return true
      }
    }

    const createErrorSpan = (fieldRef, errorAttribute) => {
      if (fieldRef && !fieldRef.querySelector('.error_field')) {
        const span = document.createElement('span')
        const errorClassList = ['invalid', 'error_field']
        span.classList.add(...errorClassList)
        const errorMessage =
          fieldRef.querySelector('input')?.getAttribute(errorAttribute) ||
          fieldRef.getAttribute(errorAttribute)
        span.innerHTML = errorMessage
        fieldRef.append(span)
      }
    }

    const removeErrorSpanIfExists = (fieldRef) => {
      if (fieldRef) {
        fieldRef.querySelector('.error_field') &&
          fieldRef
            .querySelectorAll('.error_field')
            .forEach((e) => e.parentNode.removeChild(e))
      }
    }

    const setNudgeTrackingValue = () => {
      const hasExistingCookie = checkCookie('gc_onboarding_experiment')
      const isAppStorePage =
        document.location.pathname.indexOf('mobile-forms-apps') !== -1
      const experimentValue = isAppStorePage
        ? 'onboard_nudge_app_true'
        : 'onboard_nudge_app_false'
      if (!hasExistingCookie) {
        setCookie('gc_onboarding_experiment', experimentValue)
      }
    }

    /**
     *  Create the nudge
     */
    const createMessageNudgeSpan = (eleRef, wrapper) => {
      const span = document.createElement('span')
      const errorClassList = ['invalid', 'nudge', 'error_field']
      span.classList.add(...errorClassList)
      span.innerHTML = emailWarningMsg
      wrapper.append(span)

      eleRef.target.setAttribute('nudge', true)
      eleRef.target.classList.add('nudge_user_email')
      nudgeTracker.wasNudgeDisplayed = true
      setNudgeTrackingValue()
    }

    /**
     *  Logic to remove the nudge from the dom
     */
    const removeMessageNudgeSpan = (eleRef) => {
      const { wrapper: emailWrapperDiv } = formInputs['user_email']
      emailWrapperDiv.querySelector('.nudge') &&
        emailWrapperDiv
          .querySelectorAll('.nudge')
          .forEach((e) => e.parentNode.removeChild(e))

      if (nudgeTracker.wasNudgeDisplayed) {
        nudgeTracker.isDismissed = true
      }
      const element = eleRef.target || eleRef
      element.removeAttribute('nudge')
      element.classList.remove('nudge_user_email')
    }

    /**
     *  Add invalid class to passed element ref
     */
    const showInputErrorState = (field) => {
      field.classList.add('invalid')
    }

    /**
     *  Remove invalid class to passed element ref
     */
    const hideInputErrorState = (field) => {
      field.classList.remove('invalid')
    }

    /**
     * Validate first & last name fields
     */
    const validateName = (name) => {
      const trimmedName = trimSpaces(name.value)
      if (trimmedName.length == 0) {
        name.value = ''
      }
      return name.value.length > 0
    }
    /** Valid class keeps the label above the input?  */
    const addValidClassToInput = (input) => {
      const classList = [...input.classList]
      !classList.includes('valid') && input.classList.add('valid')
    }

    /**
     * Pulled from old validation
     *
     */
    const isNumber = function (evt) {
      evt = evt ? evt : window.event
      const charCode = evt.which ? evt.which : evt.keyCode
      if (
        charCode > 31 &&
        (charCode < 48 || (charCode > 57 && (charCode < 96 || charCode > 105)))
      ) {
        evt.preventDefault()
        return false
      }
      return true
    }

    const validatePhoneField = (e) => {
      if (getCountryValue() == 'United States of America') {
        const regex = /[!@#$%^&*_+\=\[\]{};':"\\|,.<>\/?]+/
        const doesEndInDigit = /\d+$/
        const containsInvalidChars = regex.test(e.value)
        const endsInDigit = doesEndInDigit.test(e.value)
        if (!containsInvalidChars && endsInDigit && e.value.length == 14) {
          e.setCustomValidity('')
          return true
        } else if (containsInvalidChars) {
          e.setCustomValidity('Please enter a valid phone number')
          return false
        } else {
          e.setCustomValidity('Please enter a valid phone number')
          return false
        }
      } else {
        if (!e.value.length) {
          e.classList.contains('valid') && e.classList.remove('valid')
        }
        return true
      }
    }

    const validateIndustyField = () => {
      return (
        document.querySelector('.select-selected').innerText != 'Industry *'
      )
    }

    const trimSpaces = (input) => {
      return input.replace(/^\s+|\s+$/g, '')
    }

    const validatePassword = () => {
      const pw = trimSpaces(
        document.querySelector(formInputs['password'].selector).value
      )
      if (pw.length == 0) {
        document.querySelector(formInputs['password'].selector).value = ''
      }
      return document.querySelector(formInputs['password'].selector).value
        ?.length >= 6
        ? true
        : false
    }

    const fieldElements = [
      {
        name: 'user_first_name',
        selector: '.user_first_name',
        validate: validateName,
      },
      {
        name: 'user_last_name',
        selector: '.user_last_name',
        validate: validateName,
      },
      {
        name: 'user_email',
        selector: '.user_email',
        validate: validateEmail,
      },
      {
        name: 'phone-number',
        selector: '.phone-number',
        validate: validatePhoneField,
        updateAttribute: true,
      },
      {
        name: 'password',
        selector: '.password',
        validate: validatePassword,
      },
      {
        name: 'custom-select',
        selector: '.custom-select',
        validate: validateSelect,
        updateAttribute: true,
      },
    ]

    const attributeMap = {
      'custom-select': [
        {
          attribute: 'data-required-message',
          message: 'Industry is required',
        },
        {
          attribute: 'tabindex',
          message: '0',
        },
      ],
      'phone-number': [
        {
          attribute: 'data-invalid-message',
          message: 'Please enter a valid phone number',
        },
      ],
    }

    const formInputs = fieldElements.reduce((formInputList, value) => {
      const { name, selector, validate, updateAttribute } = value
      const element = signUpForm.querySelector(selector)
      if (element) {
        formInputList[name] = {
          name,
          field: element,
          wrapper: getParentElement(selector),
          validate,
          selector,
        }

        if (updateAttribute) {
          for (let attr of attributeMap[name]) {
            attr.attribute == 'tabindex'
              ? updateElementAttribute(
                  document.querySelector('.custom-select'),
                  attr.attribute,
                  attr.message
                )
              : updateElementAttribute(
                  getParentElement(selector),
                  attr.attribute,
                  attr.message
                )
          }
        }
        return formInputList
      }
      return formInputList
    }, {})

    const formatPhoneNumber = function (e) {
      const elem = formInputs['phone-number'].field

      if (getCountryValue() == 'United States of America') {
        let ph = elem.value.replace(/\D/g, '').substring(0, 9)
        // Backspace and Delete keys
        const deleteKey = e.keyCode === 8 || e.keyCode === 46
        const len = ph.length
        if (len === 0) {
          ph = ph
        } else if (len < 3) {
          ph = '(' + ph
        } else if (len === 3) {
          ph = '(' + ph + (deleteKey ? '' : ') ')
        } else if (len < 6) {
          ph = '(' + ph.substring(0, 3) + ') ' + ph.substring(3, 6)
        } else if (len === 6) {
          ph =
            '(' +
            ph.substring(0, 3) +
            ') ' +
            ph.substring(3, 6) +
            (deleteKey ? '' : '-')
        } else {
          ph =
            '(' +
            ph.substring(0, 3) +
            ') ' +
            ph.substring(3, 6) +
            '-' +
            ph.substring(6, 9)
        }

        elem.value = ph
        if (ph.length < 13) {
          elem.setCustomValidity('Please enter a valid phone number')
        } else {
          elem.setCustomValidity('')
        }
      }
    }

    /**
     *
     * We used classes instead if IDs. So we need to check the element and see if it contains a class we deemed as validateable,
     * and return that class so we can pull the validation method
     */
    const pullValidateableClassFromClassList = (eleRef) => {
      const validateableClasses = [
        'user_email',
        'user_first_name',
        'user_last_name',
        'password',
        'phone-number',
        'custom-select',
      ]

      return [...eleRef.classList].filter((className) => {
        if (validateableClasses.includes(className)) {
          return className
        }
      })[0]
    }

    const validate = (eleRef) => {
      const element = eleRef?.target || eleRef
      if (!element) {
        return
      }

      addValidClassToInput(element)

      /**
       *  Grab the ref to the field based on id or class name, and grab its validation method
       */

      const isIndustryField = element.classList.contains('custom-select')
      const { wrapper: wrapperElement, validate } =
        formInputs[pullValidateableClassFromClassList(element)] || {}

      /**
       * Run the validation method and store the result.
       */
      const isValid = validate(element)

      if (isValid && !element.getAttribute('nudge')) {
        removeErrorSpanIfExists(wrapperElement)
        hideInputErrorState(element)
      } else if (!element.getAttribute('nudge')) {
        const errorMessage = isIndustryField
          ? 'data-required-message'
          : whichError(element.validity)
        removeErrorSpanIfExists(wrapperElement)
        createErrorSpan(wrapperElement, errorMessage)
        showInputErrorState(element)
      }
    }

    const emailOnInput = (eleRef) => {
      const { wrapper } = formInputs['user_email']
      if (checkEmailBlacklist(eleRef.target.value)) {
        removeErrorSpanIfExists(wrapper)
        createMessageNudgeSpan(eleRef, wrapper)
        showInputErrorState(eleRef.target)
      } else if (
        !checkEmailBlacklist(eleRef.target.value) &&
        validateEmail(eleRef.target)
      ) {
        removeErrorSpanIfExists(wrapper)
        removeMessageNudgeSpan(eleRef)
        hideInputErrorState(eleRef.target)
      } else {
        eleRef.target.removeAttribute('nudge')
      }
    }

    /**
     *  Hook the event listner to the fields on the form.
     *  If its two step, we need to validate company name, industry, phone and password in addition to
     *  first  name, last name and email
     *
     * otherwise we just validate first  name, last name and email
     */
    /**
     * Lets add the event listeners to the form fields.
     * @param {} eleRef
     */

    const formInputKeys = Object.keys(formInputs)
    formInputKeys.forEach((key) => {
      const { field, name } = formInputs[key]
      field.addEventListener('blur', (e) => validate(e))
      if (name == 'phone-number') {
        field.addEventListener('keydown', (e) => isNumber(e))
        field.addEventListener('keypress', (e) => formatPhoneNumber(e))
        field.addEventListener('paste', () => false)
      }
      if (name == 'custom-select') {
        field.addEventListener('click', (e) => validateSelect(e))
      }
      if (name == 'user_email') {
        field.addEventListener('input', (e) => emailOnInput(e))
      }
    })

    const runFormValidationOnSubmit = () => {
      validate(formInputs['user_first_name'].field)
      validate(formInputs['user_last_name'].field)
      validate(formInputs['user_email'].field)

      /** Basically, if we validate and it contains the nudge, lets remove the error state
       *  and flip the nudge logic to say we showed the nudge and user dismissed it
       *
       *
       */
      if (
        formInputs['user_email'].field.classList.contains('nudge_user_email')
      ) {
        removeErrorSpanIfExists(formInputs['user_email'].wrapper)
        removeMessageNudgeSpan(formInputs['user_email'].field)
        hideInputErrorState(formInputs['user_email'].field)
      }
    }

    const runStep2ValidationOnSubmit = () => {
      validate(formInputs['phone-number'].field)
      validate(formInputs['password'].field)
      validateSelect(formInputs['custom-select'].selector)
    }

    const doesFormContainValidationErrors = () => {
      return signUpForm.querySelectorAll('.error_field')?.length > 0
        ? true
        : false
    }

    const onSubmit = (e, isTwoStep) => {
      isTwoStep ? runStep2ValidationOnSubmit() : runFormValidationOnSubmit()

      if (doesFormContainValidationErrors()) {
        e.preventDefault()
        console.warn('form contained validation errors')
      }
      executeRecaptcha()
    }

    formInputs['user_email'].field.addEventListener('input', (e) =>
      emailOnInput(e)
    )

    /**
     *  If the two step button exists, add event listner
     */
    if (twoStepBtn) {
      twoStepBtn.addEventListener('click', (e) => onSubmit(e, true))
    }

    const companyNameField = document.querySelector('.company-name')
    if (companyNameField) {
      companyNameField.addEventListener('blur', (e) => {
        if (e.target.value.length > 0) {
          addValidClassToInput(e.target)
        } else {
          e.target.classList.contains('valid') &&
            e.target.classList.remove('valid')
        }
      })
    }
    submitBtn.addEventListener('click', (e) => onSubmit(e, false))

    const executeRecaptcha = () => {
      grecaptcha.ready(function () {
        grecaptcha
          .execute('6LfE68wUAAAAANztJaT-WWfH7H42rqIZ7wOQ4YIq')
          .then(function (token) {
            return token
          })
      })
    }
  }

  const init = (selector) => {
    const forms = document.querySelectorAll(selector)

    forms.forEach((form) => new newFormValidate({ form }))
  }

  init('.new_form_validate')
})(window)
